import React from 'react';
import Link from 'components/Link';
import s from './ElectionLiveBlogs.scss';

function ElectionLiveBlogs({ sectionData, isWapView }) {
  const numRows = 5;
  const numColumns =
    sectionData.items &&
    Array.isArray(sectionData.items) &&
    sectionData.items.length > 0
      ? Math.ceil(sectionData.items.length / numRows)
      : 0;

  return (
    <div className={s.electionLiveBlogs}>
      {(sectionData?.name || sectionData?.subHeading) && (
        <div className={s.electionLiveBlogsTitle}>
          {sectionData?.name && (
            <>
              <div className={s.elbMianTitle}>{sectionData?.name}</div>
              {!isWapView && <span />}
            </>
          )}
          {sectionData?.subHeading && (
            <div className={s.elbSubTitle}>{sectionData?.subHeading}</div>
          )}
        </div>
      )}
      <div className={s.electionLiveBlogsInner}>
        <div className={s.linkWrap}>
          {(() => {
            const links = [];
            for (let col = 0; col < numColumns; col += 1) {
              const columnLinks = [];
              for (let row = 0; row < numRows; row += 1) {
                const dataIndex = col * numRows + row;
                if (dataIndex < sectionData.items.length) {
                  const item = sectionData.items[dataIndex];
                  columnLinks.push(
                    <Link
                      key={dataIndex}
                      to={item.wu}
                      ga4Data={
                        sectionData.ga4Type && [
                          {
                            event: 'user_click',
                            type: `${sectionData.ga4Type}`,
                            category: 'story_click',
                            story_no: `${dataIndex}`,
                          },
                        ]
                      }
                    >
                      {item.hl}
                    </Link>,
                  );
                }
              }
              links.push(<div className={s.links}>{columnLinks}</div>);
            }
            return links;
          })()}
        </div>
      </div>
    </div>
  );
}

export default ElectionLiveBlogs;
